export const BUDGET_CHART_VIEW = {
  BUDGET_ADJUSTMENTS: "BUDGET_ADJUSTMENTS",
  BUDGET_PROGRESS: "BUDGET_PROGRESS",
  CONTINGENCY_USAGE: "CONTINGENCY_USAGE",
};
